// organize-imports-ignore
// The polyfills must be imported first, before any module that might rely on them.
import './polyfills'

import App from '@/App.vue'
import router from '@/router'
import { createApp } from 'vue'
import './assets/styles/index.scss'
import './registerServiceWorker'

createApp(App).use(router).mount('#app')
